import { render } from "./ProviderDetailsComponent.vue?vue&type=template&id=dfd3f1a2&scoped=true&ts=true"
import script from "./ProviderDetailsComponent.vue?vue&type=script&lang=ts"
export * from "./ProviderDetailsComponent.vue?vue&type=script&lang=ts"

import "./ProviderDetailsComponent.vue?vue&type=style&index=0&id=dfd3f1a2&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/Bookit.BO/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dfd3f1a2"]])

export default __exports__